// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2g1iJ","empty":"ModalGraph_empty__1kk4L"};